import React from 'react';
import { Link } from 'react-router-dom';

import BrandLogo from 'components/brand-logo/brand-logo';
import { t } from 'utils/i18n';

interface Props {
    projectId: number | null;
    projectName: string | null;
    taskId: number;
    taskName: string | null;
}

// Router links, so the container's history.block still guards unsaved changes.
export default function Breadcrumb({
    projectId, projectName, taskId, taskName,
}: Props): JSX.Element {
    return (
        <nav aria-label={t('Breadcrumb')} className='cvat-workspace-breadcrumb'>
            <Link to='/projects' className='cvat-workspace-logo' aria-label={t('Projects')}>
                <BrandLogo />
            </Link>
            {projectId !== null && (
                <>
                    <Link to={`/projects/${projectId}`} className='cvat-workspace-breadcrumb-link'>
                        {projectName ?? t('Project #{id}', { id: projectId })}
                    </Link>
                    <span className='cvat-workspace-breadcrumb-separator'>/</span>
                </>
            )}
            <span className='cvat-workspace-breadcrumb-current'>{taskName ?? t('Task #{id}', { id: taskId })}</span>
        </nav>
    );
}
